/* eslint-disable react/no-danger */
import * as React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import { isPartnersPageMigrationEnabled } from 'bundles/partners-graphql/utils/experiments';
import { clearEmptyFields } from 'bundles/seo/utils/utils';

class PartnerPageGoogleSchemaMarkup extends React.Component {
  static propTypes = {
    partner: PropTypes.object,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'partner' does not exist on type 'Readonl... Remove this comment to see the full error message
    const { partner } = this.props;
    const partnerPagePath = isPartnersPageMigrationEnabled()
      ? `/partners/${partner.shortName}`
      : `/${partner.shortName}`;

    // Get unique list of items using the id field to check if item already exists in the array
    const items = _.uniqBy([...partner.specializations.elements, ...partner.courses.elements], 'id');
    const markupJson = {
      '@context': 'http://schema.org',
      '@type': 'WebPage',
      Name: `${partner.name} | Coursera`,
      url: `https://www.coursera.org${partnerPagePath}`,
      about: {
        '@id': `https://www.coursera.org${partnerPagePath}#institution`,
        '@type': 'CollegeOrUniversity',
        name: partner.name,
        description: partner.description,
        logo: `${partner.squareLogo}`,
        url: `https://www.coursera.org${partnerPagePath}`,
        sameAs: Object.values(partner.links),
      },
      mainEntity: {
        '@type': 'ItemList',
        itemListElement: items.map((item, i) =>
          item.courseType
            ? {
                '@type': 'ListItem',
                position: i + 1,
                '@id': `https://www.coursera.org/learn/${item.slug}#mooc`,
                url: `https://www.coursera.org/learn/${item.slug}`,
              }
            : {
                '@type': 'ListItem',
                position: i + 1,
                '@id': `https://www.coursera.org/specializations/${item.slug}#specialization`,
                url: `https://www.coursera.org/specializations/${item.slug}`,
              }
        ),
      },
    };

    const createMarkup = () => ({
      __html: `
        <script type="application/ld+json">
          ${JSON.stringify(clearEmptyFields(markupJson))}
        </script>
      `,
    });

    return (
      <div className="rc-PartnerPageGoogleSchemaMarkup">
        <div dangerouslySetInnerHTML={createMarkup()} />
      </div>
    );
  }
}

export default PartnerPageGoogleSchemaMarkup;
